<div
  class="lcl-search-port-input"
  [ngClass]="{ 'lcl-search-port-input-external': isExternal, 'lcl-search-port-input-has-error': fc.invalid && isSubmitted }"
>
  <div class="lcl-search-port-input-title" [ngClass]="{ 'lcl-search-port-input-title-external': isExternal }">
    <h3 class="lcl-search-port-input-title-header">{{ title | translate }}</h3>
    <h5 class="lcl-search-port-input-title-validation" *ngIf="fc.invalid && isSubmitted">{{ "LABELS.REQUIRED" | translate }}</h5>
  </div>

  <div class="lcl-search-port-input-select-dropdown">
    <img src="assets/icons/icon_ancore_blue_md.svg" class="lcl-search-port-input-select-dropdown-icon" *ngIf="isExternal" />
    <img src="assets/icons/icon_ancore_gray_md.svg" class="lcl-search-port-input-select-dropdown-icon" *ngIf="!isExternal" />

    <app-control-wrapper [control]="fc" [isShowHelper]="false">
      <ng-select
        class="custom"
        control-wrapper
        bindLabel="label"
        bindValue="id"
        [multiple]="false"
        [id]="fcName"
        [formControl]="fc"
        [placeholder]="'COUNTRY_OR_PORT' | translate"
        [clearable]="true"
        [typeahead]="portsInput$"
        [loading]="portsLoading"
        [items]="ports"
        (search)="onSearch.emit()"
        (clear)="onClear.emit()"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="lcl-search-port-input-selected" [title]="item.displayName + ' (' + item.unCode + '), ' + item.country?.description">
            <strong class="lcl-search-port-input-selected-strong">{{ item.displayName }}</strong>
            <span class="lcl-search-port-input-selected-country">({{ item.unCode }}), {{ item.country?.description }}</span>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="lcl-search-port-input-select-row" [title]="item.displayName + ' (' + item.unCode + '), ' + item.country?.description">
            <div class="lcl-search-port-input-select-icon">
              <img src="assets/icons/icon_ancore_gray_sm.svg" />
            </div>
            <div class="lcl-search-port-input-select-text">
              <div class="lcl-search-port-input-select-text-left">
                <div class="lcl-search-port-input-select-text-left-header">
                  {{ item.displayName }}
                </div>
                <div class="lcl-search-port-input-select-text-left-hint">
                  {{ item.country?.description }}
                </div>
              </div>
              <div class="lcl-search-port-input-select-text-right">
                {{ item.unCode }}
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template ng-typetosearch-tmp>
          <div class="lcl-search-port-input-select-row">
            <div class="lcl-search-port-input-select-icon">
              <img src="assets/icons/icon_ancore_gray_sm.svg" />
            </div>
            <div class="lcl-search-port-input-select-text">
              <div class="lcl-search-port-input-select-text-left-header">
                {{ "TYPE_TO_SEARCH" | translate }}
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template ng-notfound-tmp>
          <div class="lcl-search-port-input-select-row">
            <div class="lcl-search-port-input-select-icon">
              <img src="assets/icons/icon_ancore_gray_sm.svg" />
            </div>
            <div class="lcl-search-port-input-select-text">
              <div class="lcl-search-port-input-select-text-left-header">
                {{ "NO_MATCH_FOUND" | translate }}
              </div>
            </div>
          </div>
        </ng-template>
      </ng-select>
    </app-control-wrapper>
  </div>
</div>
